var render = function render(_c,_vm){return _c('el-switch',{staticStyle:{"display":"block"},attrs:{"value":[1, 'SI'].includes(_vm.props.row[`${_vm.props.column}`]) ? true : false,"active-color":"#6BA652","inactive-color":"#ff4c4c"}})
}
var staticRenderFns = []

export { render, staticRenderFns }